import { render, staticRenderFns } from "./BranchPostIndexReportView.vue?vue&type=template&id=92ae9ea2&scoped=true"
import script from "./BranchPostIndexReportView.vue?vue&type=script&lang=js"
export * from "./BranchPostIndexReportView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92ae9ea2",
  null
  
)

export default component.exports